import(/* webpackMode: "eager", webpackExports: ["SnapLoader"] */ "/vercel/path0/src/components/snap-loader.tsx");
